const tours = {
  availableEscapes: "Fughe disponibili", // translated
  tours: "Tour", // translated
  selectRoom: "Seleziona una stanza", // translated
  tour: "Tour", // translated
  addOns: "Componenti aggiuntivi", // translated
  sendRequest: "Invia richiesta", // translated
  getRequest: "Ottieni richiesta", // translated
  availableExperiences: "Esperienze disponibili", // translated
  addOn: "Aggiungi su", // translated
};

export default tours;
